export const YYYY_MM_DD_PATTERN = new RegExp(/\d{4}-\d{2}-\d{2}/);
export const INTEGER_PATTERN = new RegExp(/^[1-9]\d*$/);
export const FLOATING_NUMBER_PATTERN = new RegExp(/^[1-9]\d*\.\d*|0\.\d*[1-9]\d*$/);
export const GOOGLE_DRIVE_LINK_PATTERN = /^\s*https:\/\/drive.google.com.*/;
